export default function getVisiblePeopleIds(party) {
  return party.peopleIds.filter(
    (personId) => !party.removedPeopleIds.includes(personId)
  )
}
